export default function Legend({ log, french, levelToColor }) {
  // Sécurité : Si l'échelle n'est pas encore prête, on ne rend rien au lieu de crash
  if (!log || typeof log.ticks !== "function") return null

  return (
    <div
      className="carto-legend"
      role="region"
      aria-label={french ? "Légende de la carte" : "Map legend"}
    >
      <div className="carto-legend-title">
        {french ? "Échelle" : "Scale"} (cg/L)
      </div>
      <div
        className="carto-legend-container"
        style={{ display: "flex", gap: "2px" }}
      >
        {log.ticks(8).map((tick, index) => (
          <div className="carto-legend-element" key={index}>
            <div
              className="carto-legend-scale"
              style={{
                background: levelToColor(tick),
                width: "30px",
                height: "10px",
              }}
            >
              <span
                style={{ fontSize: "9px", display: "block", marginTop: "12px" }}
              >
                {tick > 0 ? (tick / 1000).toFixed(0) + "K" : tick}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
